import { render } from "./InvoiceTable.vue?vue&type=template&id=1363b4ba&scoped=true"
import script from "./InvoiceTable.vue?vue&type=script&lang=js"
export * from "./InvoiceTable.vue?vue&type=script&lang=js"

import "./InvoiceTable.vue?vue&type=style&index=0&id=1363b4ba&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1363b4ba"]])

export default __exports__